import { Box, Divider, Stack, Typography } from "@mui/material";
import { FormattedNumber } from "react-intl";
import React, { FC } from "react";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper.tsx";
import { ProductAttributes } from "../../../../../Domains/Products/api/productJsonApi.ts";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Link } from "react-router";
import { useVestigingContext } from "../../../components/Forms/VestigingProvider";
import { BaseAttributes } from "@jamezz/react-components";

type AutocompleteRenderOptionProps<T extends BaseAttributes> = {
  option: T;
};

export const RenderOption: FC<AutocompleteRenderOptionProps<ProductAttributes>> = ({ option }) => {
  const isInaccessibleProduct = !option.is_actief || option.blocked;
  const venue = useVestigingContext().vestiging;
  let currency = "EUR";

  if (venue && venue.valuta) {
    currency = venue.valuta;
  }

  return (
    <Stack
      direction={"column"}
      alignItems={"stretch"}
      sx={{ color: isInaccessibleProduct ? "grey" : undefined }}
      flex={1}
    >
      <Stack direction={"row"} justifyContent={"space-between"} sx={{ width: 1 }}>
        <Typography component={"span"} sx={{ textDecoration: isInaccessibleProduct ? "line-through" : undefined }}>
          {option.naam}
        </Typography>
        <Link
          to={`/manager/producten/${option.id}/edit?tabIndex=0`}
          target={"_blank"}
          onClick={(e) => e.stopPropagation()}
        >
          <OpenInNewIcon sx={{ color: "grey" }} />
        </Link>
      </Stack>
      <Box>
        {option.blocked ? (
          <Typography component={"b"}>
            <TranslationWrapper tDefault={"Product is blocked"} tKey={"async_autocomplete.product.label.is_blocked"} />
          </Typography>
        ) : !option.is_actief ? (
          <Typography component={"b"}>
            <TranslationWrapper
              tDefault={"Product is inactive"}
              tKey={"async_autocomplete.product.label.is_inactive"}
            />
          </Typography>
        ) : null}
      </Box>
      <Stack direction={"row"} justifyContent={"space-between"}>
        <Typography component={"span"} color={"grey"}>
          #{option.id}
        </Typography>
        <FormattedNumber value={option.prijs} style={"currency"} currency={currency ?? "EUR"} />
      </Stack>
      <Divider />
    </Stack>
  );
};
